import getNormalizedRide from './getNormalizedRide';

const getNormalizedRides = (rides = []) => rides.map(getNormalizedRide);

export default getNormalizedRides;
